import React, { useState } from 'react';
import styled from 'styled-components';
import GlobalStyles from './GlobalStyles';
import TopMenuBar from './TopMenuBar';
import MiddleContent from './MiddleContent';
import BottomStrip from './BottomStrip';

const AppWrapper = styled.div`
  background-color: #000009;
  color: yellow;
`;

const App = () => {
  const [statusText, setStatusText] = useState('');

  const handleMenuButtonClick = async (buttonName) => {
    try {
      const response = await fetch(`http://localhost:8080/portfolio/${buttonName}`);
      const data = await response.text();
      setStatusText(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AppWrapper>
      <GlobalStyles />
      <TopMenuBar onMenuButtonClick={handleMenuButtonClick} />
      <MiddleContent />
      <BottomStrip statusText={statusText} />
    </AppWrapper>
  );
};

export default App;

